import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllLanguageManagers extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LanguageManagers/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteALanguageManager extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LanguageManagers/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateLanguageManager extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LanguageManagers/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetASingleLanguageManager extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LanguageManagers/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateALanguageManager extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LanguageManagers/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllLanguageManagers,
  DeleteALanguageManager,
  CreateLanguageManager,
  GetASingleLanguageManager,
  UpdateALanguageManager,
};
